import { useIsPeopleUnlockButtonLoading } from '@aibees/elephant/components/people-unlock/hooks/use-is-people-unlock-button-loading';
import { ProfileDetailsNoData } from '@aibees/elephant/components/profile-details-no-data';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { ContactDetailItemHeader } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-detail-item-header';
import { useSetSeemoreVisibility } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/hooks/use-set-seemore-visibility';
import { doesContactDetailHaveUpdate } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/utils';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { useContactDetailsState } from '../../context';
import * as EXTERNALSX from '../../sx';
import { VolunteerItem } from './components/volunteer-item';
import * as SX from './sx';
import type { VolunteerProps as Props } from './types';

export const Volunteer = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const { api } = usePersonReadDataContext();
    const { loadingContactDetails } = useIsPeopleUnlockButtonLoading(api.data);
    const { unlocked, isPopoverType } = useContactDetailsState();
    useSetSeemoreVisibility(
      setShowSeeMore,
      itemsLimit,
      api.data?.volunteerExperiences?.length
    );
    const hasUpdate = doesContactDetailHaveUpdate(
      PersonContactDetailsItem.VOLUNTEER_EXPERIENCES,
      api.data
    );
    const content = (
      <Stack direction="column" gap={1}>
        {hasUpdate && api.data?.volunteerExperiences?.[0] && (
          <div
            key={-1}
            style={{
              filter: 'blur(4px)',
            }}
            onClick={(e) => e.preventDefault()}
          >
            <VolunteerItem
              key={-1}
              item={api.data?.volunteerExperiences?.[0]}
              index={-1}
            />
          </div>
        )}

        {api.data?.volunteerExperiences?.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          return <VolunteerItem key={index} item={item} index={index} />;
        })}
      </Stack>
    );

    return (
      <Box className={classnames('Volunteer', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Volunteer"
          count={api.data?.volunteerExperiences?.length ?? 0}
        />

        {!unlocked || loadingContactDetails ? (
          <ProfileDetailsNoData />
        ) : isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

Volunteer.displayName = 'Volunteer';
